
import Button from '../../../components/base/Button';

export default function CommunitySection() {
  const spotlights = [
    {
      title: "Rural Health Initiative",
      location: "Manitoba",
      professional: "Dr. Sarah Mitchell, PharmD",
      description: "Implementing collaborative care model between local pharmacy and veterinary clinic to serve rural communities.",
      image: "https://public.readdy.ai/ai/img_res/8ee93083f43a9cccdee74de22d5f7ca5.jpg",
      impact: "Serving 2,500+ residents"
    },
    {
      title: "Emergency Response Team",
      location: "British Columbia",
      professional: "Dr. James Wong, DVM",
      description: "Leading disaster response efforts coordinating human and animal emergency care during natural disasters.",
      image: "https://readdy.ai/api/search-image?query=Emergency%20healthcare%20response%20team%20with%20veterinarians%20and%20pharmacists%2C%20disaster%20relief%20medical%20tent%2C%20emergency%20medical%20services%2C%20professional%20emergency%20response%20coordination&width=350&height=200&seq=comm3&orientation=landscape",
      impact: "24/7 Emergency Support"
    },
    {
      title: "Indigenous Health Partnership",
      location: "Ontario",
      professional: "Maria Gonzalez, RPh",
      description: "Developing culturally sensitive healthcare programs that honor traditional healing alongside modern medicine.",
      image: "https://readdy.ai/api/search-image?query=Indigenous%20healthcare%20partnership%2C%20traditional%20and%20modern%20medicine%20collaboration%2C%20cultural%20healthcare%20setting%2C%20respectful%20medical%20consultation%20with%20indigenous%20community&width=350&height=200&seq=comm4&orientation=landscape",
      impact: "15 Communities Served"
    }
  ];

  const achievements = [
    {
      title: "Community Health Awards",
      count: "12",
      description: "Members recognized for outstanding community service"
    },
    {
      title: "Innovation Grants",
      count: "$850K",
      description: "Funding provided for community health innovations"
    },
    {
      title: "Volunteer Hours",
      count: "15,000+",
      description: "Annual volunteer hours contributed by members"
    },
    {
      title: "Lives Impacted",
      count: "75,000+",
      description: "Canadians served through community programs"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-community-line text-2xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Community Spotlights
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Celebrating success stories, innovative practices, and community impact across Canada's healthcare landscape.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {spotlights.map((spotlight, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
              <img
                src={spotlight.image}
                alt={spotlight.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                    {spotlight.location}
                  </span>
                  <span className="text-sm text-gray-500">{spotlight.impact}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {spotlight.title}
                </h3>
                <p className="text-sm font-medium text-gray-700 mb-3">
                  {spotlight.professional}
                </p>
                <p className="text-gray-600 mb-4">
                  {spotlight.description}
                </p>
                <Button variant="outline" size="sm">
                  Read Full Story
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 text-white">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-4">Community Impact</h3>
            <p className="text-blue-100 max-w-2xl mx-auto">
              Our members are making a real difference in communities across Canada through innovative healthcare solutions.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl font-bold mb-2">{achievement.count}</div>
                <div className="text-lg font-semibold mb-1">{achievement.title}</div>
                <div className="text-blue-200 text-sm">{achievement.description}</div>
              </div>
            ))}
          </div>
          
          <div className="text-center">
            <Button className="bg-white text-blue-900 hover:bg-gray-100">
              Share Your Story
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
